module.exports = __webpack_public_path__ + "static/media/swimmer.9c23eb45.jpg";